import './action.scss';

import { createElementFromHTML, tryParseJSON, fadeOut } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';

class ActionHandler {
    constructor (el, options) {
        const defaults = {
            initAttr: 'data-action',
            typeAttr: 'data-action-type',
            hrefAttr: 'data-href',
            tooltipAttr: 'i'
        };
        this.settings = Object.assign({}, defaults, options);
        this.body = document.body;
        this.$actionHandler = el;
        this.type = this.$actionHandler.getAttribute(this.settings.typeAttr);
        this.$tooltip = this.$actionHandler.querySelector(this.settings.tooltipAttr);
        this.newCopy = '';
        this.newChangeCopy = '';
        this.translations = window.translations;
    }

    initialize () {
        this.setEvents();
    }

    addLoginInfo (uri) {
        const $overlay = createElementFromHTML('<div class="login-overlay" />');
        const $overlayInner = createElementFromHTML('<div class="login-overlay__inner" />');
        const $overlayContent = createElementFromHTML('<div class="login-overlay__content" />');
        const $overlayClose = createElementFromHTML('<a role="button" class="login-overlay__close action action--close" data-hover="hover"><i>' + this.translations.closeOverlay + '</i></a>');

        let contentCopy = '<p><strong>' + this.translations.login_feature + '</strong></p>';
        contentCopy += '<a href="' + uri + '" class="button">' + this.translations.to_login + '</a>';

        $overlayContent.innerHTML = contentCopy;
        $overlayInner.appendChild($overlayClose);
        $overlayInner.appendChild($overlayContent);
        $overlay.appendChild($overlayInner);
        document.body.appendChild($overlay);

        $overlayClose.addEventListener('click', (e) => {
            fadeOut($overlay);
            e.preventDefault();
        });
    }

    sendFavorite ($element, state) {
        const uri = $element.getAttribute(this.settings.hrefAttr);
        const favMethod = 'GET';

        new AjaxLoad(uri + '?state=' + state, { // eslint-disable-line
            requestMethod: favMethod,
            onSuccess: (result) => {
                const JSONresponse = tryParseJSON(result);

                if (JSONresponse.success === false) {
                    if (state === true) {
                        this.setStateActive($element, false);
                    } else {
                        this.setStateActive($element, true);
                    }

                    if (JSONresponse.url !== '') {
                        this.addLoginInfo(JSONresponse.url);
                    }
                }
            }
        });
    }

    checkType ($element, actionType, state) {
        switch (actionType) {
        case 'favorite':
            this.sendFavorite($element, state);
            break;
        default:
            break;
        }
    }

    setStateActive (obj, state) {
        if (state === true) {
            obj.classList.add('is--active');
        } else {
            obj.classList.remove('is--active');
        }

        if (this.$actionHandler.getAttribute(this.settings.initAttr) !== '') {
            this.newCopy = this.$actionHandler.getAttribute(this.settings.initAttr);
            this.newChangeCopy = this.$tooltip.textContent.trim();
            this.$tooltip.textContent = this.newCopy;
            this.$actionHandler.setAttribute(this.settings.initAttr, this.newChangeCopy);
        }

        return state;
    }

    setEvents () {
        this.$actionHandler.addEventListener('click', (e) => {
            let state = '';

            if (this.$actionHandler.classList.contains('is--active')) {
                state = this.setStateActive(this.$actionHandler, false);
            } else {
                state = this.setStateActive(this.$actionHandler, true);
            }

            this.checkType(this.$actionHandler, this.type, state);

            e.preventDefault();
        });
    }
}

export { ActionHandler };
